<template>
    <v-row justify="center">
    <v-dialog v-model="abrir" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                  <v-textarea
                    solo
                    name="input-7-4"
                    label="Escriba un comentario..."
                    v-model="observacion"
                  ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="abrir = false">Cancelar</v-btn>
          <v-btn color="green darken-1" dark @click="guardar">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import {mapState} from 'vuex';
export default {
    data:()=>({
        registro:{},
        parametro:{},
        abrir:false,
        observacion:''
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_comentario_parametro');
    },
    mounted(){
        this.$parent.$on('abrir_modal_comentario_parametro',(registro,parametro)=>{
          console.log('llegandoooo');
            this.registro = registro;
            this.parametro = parametro;
            console.log('registro recibido',registro);
            console.log('parametro recibido',parametro);
            if(this.parametro == 'resultado_analisis'){
              this.observacion = this.registro.observacion;
            }else{
              this.observacion = this.registro[this.parametro.id].observacion;
            }
            console.log('comentario actual',this.observacion);
            this.abrir = true;
            console.log('yesss');
        });
    },
    methods: {
        guardar(){
            console.log('guardandoo..');
            console.log('comentario',this.observacion);
            let body = {}
            if(this.parametro == 'resultado_analisis'){
              //es una observación de resultado análisis
              body = {
                  observacion:this.observacion
              }
              let url = `${this.base_url}resultados/${this.registro.id_registro}`;
              this.axios.put(url,body,this.headers).then((response)=>{
                this.registro.observacion = response.data.data.observacion;
                console.log('actualizacion',response);
                this.$emit('observacion_actualizada',this.registro);
                this.limpiar();
              }).catch((error)=>{
                console.log('error',error);
              });
            }else{
                console.log('resultado_detalle_id',this.registro[this.parametro.id].id);
                // if(this.observacion != null && this.observacion != ''){
                body = {
                  observacion:this.observacion,
                  valor: this.registro[this.parametro.id].valor
                }
                let url = `${this.base_url}resultado_detalles/${this.registro[this.parametro.id].id}`;
                this.axios.put(url,body,this.headers).then((response)=>{
                  console.log('comentario actualizado',response);
                  this.registro[this.parametro.id].observacion = response.data.data.observacion;
                  this.$emit('actualizar_comentario_parametro',this.registro);
                  this.limpiar();
                }).catch((error)=>{
                  console.log('error',error);
                })
                // }else{
                //   this.abrir = false;
                //   this.observacion = '';
                // }
            }
              
        },
        limpiar(){
          this.abrir = false;
          this.observacion = '';
        }
    },
    computed: {
      ...mapState(['base_url','headers']),
    },
}
</script>